import { Contact, ContactType } from '@api/generated/graphql';
import maskPhoneInput from '@lib/utils/maskPhoneInput';

export type FormCustomerContact = Contact & {
  memo: string;
};

type TransformContactInput = Omit<Contact, 'id'> & {
  id?: Contact['id'];
};

/**
 * Transforms the contacts and Masks the phone numbers in the contact methods.
 *
 * @param contacts - An array of customer contact methods.
 * @returns An array of customer contact methods with a phone mask applied to non-email fields.
 */
export const transformContacts = (
  contacts: Contact[],
): FormCustomerContact[] => {
  return contacts.map((contact) => ({
    ...contact,
    memo: contact.memo ?? '',
    value:
      contact.type !== ContactType.Email
        ? maskPhoneInput(contact.value)
        : contact.value,
    jobRemindersEnabled: contact.jobRemindersEnabled,
    marketingUpdatesEnabled: contact.marketingUpdatesEnabled,
    invoiceStatementNotification: contact.invoiceStatementNotification,
  }));
};

export const transformContact = (contact: TransformContactInput) => {
  return {
    id: contact.id,
    memo: contact.memo ?? '',
    type: contact.type,
    value:
      contact.type !== ContactType.Email
        ? maskPhoneInput(contact.value)
        : contact.value,
    jobRemindersEnabled: contact.jobRemindersEnabled,
    marketingUpdatesEnabled: contact.marketingUpdatesEnabled,
    invoiceStatementNotification: contact.invoiceStatementNotification,
  };
};
